import { render } from "./pageSide.vue?vue&type=template&id=126105ce&ts=true"
import script from "./pageSide.vue?vue&type=script&lang=ts"
export * from "./pageSide.vue?vue&type=script&lang=ts"

import "./pageSide.vue?vue&type=style&index=0&id=126105ce&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__